import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { TOOLS } from "../logic/chartConfig"
import { pickTarget } from "redux/ducks/Chart"
import _ from "lodash"
import ClassNames from "classnames"

const CONVERT_TITLE = {
  AverageN: {
    MA1: ["移動平均1", "AverageN_1"],
    MA2: ["移動平均2", "AverageN_2"],
    MA3: ["移動平均3", "AverageN_3"],
    MA4: ["移動平均4", "AverageN_4"],
    MA5: ["移動平均5", "AverageN_5"],
  }, // 移動平均５本
  Ichimoku: {
    基準線: ["基準線", "Kijyun_Value"],
    転換線: ["転換線", "Tenkan_Value"],
    先行スパン1: ["先行スパン1", "Span_Value"],
    先行スパン2: ["先行スパン2", ""],
    遅行線: ["遅行線", ""],
  },
  Envelope: {
    "乖離率+1": ["乖離率+1", "Envelope_1"],
    "乖離率+2": ["乖離率+2", "Envelope_2"],
    "乖離率+3": ["乖離率+3", "Envelope_3"],
    "乖離率-1": ["乖離率-1", "Envelope_1"],
    "乖離率-2": ["乖離率-2", "Envelope_2"],
    "乖離率-3": ["乖離率-3", "Envelope_3"],
    MA: ["移動平均", "Envelope_Ma"],
  },
  KSBolinger: {
    "+σ1": ["+標準偏差1", "Bolinger_1"],
    "+σ2": ["+標準偏差2", "Bolinger_2"],
    "+σ3": ["+標準偏差3", "Bolinger_3"],
    "-σ1": ["-標準偏差1", "Bolinger_1"],
    "-σ2": ["-標準偏差2", "Bolinger_2"],
    "-σ3": ["-標準偏差3", "Bolinger_3"],
    MA: ["移動平均", "BolingerMa"],
  },
  ParabolicDiv: {
    上昇: ["上昇", ""],
    下降: ["下降", ""],
  },
  HLBand: {
    Center: ["中心線", ""],
    HLine: ["Ｈバンド", "HLBand_highPeriod"],
    LLine: ["Ｌバンド", "HLBand_lowPeriod"],
  },
  ATRChannel: {
    "+ATRチャネル1": ["+チャネル1", "ATRChannel_1"],
    "+ATRチャネル2": ["+チャネル2", "ATRChannel_2"],
    "+ATRチャネル3": ["+チャネル3", "ATRChannel_3"],
    "-ATRチャネル1": ["-チャネル1", "ATRChannel_1"],
    "-ATRチャネル2": ["-チャネル2", "ATRChannel_2"],
    "-ATRチャネル3": ["-チャネル3", "ATRChannel_3"],
    Lma: ["Lma", "ATRChannel_Lma", "ATRChannel_Atr"],
  },
  EMA: {
    EMA1: ["EMA1", "EMA_1"],
    EMA2: ["EMA2", "EMA_2"],
    EMA3: ["EMA3", "EMA_3"],
  },
  Kaiki: {
    "+σ1": ["+標準偏差1", "Kaiki_1"],
    "+σ2": ["+標準偏差2", "Kaiki_2"],
    "+σ3": ["+標準偏差3", "Kaiki_3"],
    "-σ1": ["-標準偏差1", "Kaiki_1"],
    "-σ2": ["-標準偏差2", "Kaiki_2"],
    "-σ3": ["-標準偏差3", "Kaiki_3"],
    回帰トレンド: ["回帰トレンド", "Kikan"],
  },
  Vwap: {
    VWAP: ["VWAP", ""],
  },
  RSI: {
    RSI: ["RSI", "RSI_Period"],
  },
  StocastKD: {
    "%K": ["%K", "Stocast_K"],
    "%D": ["%D", "Stocast_D"],
  },
  StocastDS: {
    "%D": ["%D", "Stocast_D"],
    "S%D": ["S%D Slow", "Stocast_S"],
  },
  PercentR: {
    PercentR: ["%R", "PercentR_Period"],
  },
  MACD: {
    MACD: ["MACD", "MACD_S", "MACD_L"],
    Signal: ["シグナル", "MACD_signal"],
    OSCI: ["OSCI(棒グラフ)", ""],
  },
  RCI3: {
    RCI1: ["RCI1", "RCI_Period1"],
    RCI2: ["RCI2", "RCI_Period2"],
    RCI3: ["RCI3", "RCI_Period3"],
  },
  CCI: {
    CCI: ["CCI", "CCI_Period"],
  },
  PsyCologic: {
    サイコロジカル: ["サイコロジカル", "PsyCologic_Period"],
  },
  ROC2: {
    ROC1: ["ROC1", "ROC_Period1"],
    ROC2: ["ROC2", "ROC_Period2"],
  },
  ATR: {
    ATR: ["ATR", "Kikan"],
  },
  MomentumS: {
    モメンタム: ["モメンタム", "Momentum_Period1"],
    モメンタムMA: ["移動平均", "Momentum_SKikan"],
  },
  DMImod: {
    "+DI": ["+DI", "DMI_dmi"],
    "-DI": ["-DI", ""],
    ADX1: ["ADX1", "DMI_Adx1"],
    ADXR1: ["ADXR1", "DMI_Adxr1"],
    ADX2: ["ADX2", "DMI_Adx2"],
    ADXR2: ["ADXR2", "DMI_Adxr2"],
  },
  AroonIndi: {
    AroonUp: ["UP期間", "AroonIndi_UpPeriod"],
    AroonDown: ["DOWN期間", "AroonIndi_DownPeriod"],
  },
  AroonOsci: {
    AroonOsci: ["AroonOsci", "AroonOsci_UpPeriod", "AroonOsci_DownPeriod"],
  },
  Kairi3: {
    乖離率1: ["移動平均乖離率1", "Kairi3_1"],
    乖離率2: ["移動平均乖離率2", "Kairi3_2"],
    乖離率3: ["移動平均乖離率3", "Kairi3_3"],
  },
  VolumeMa3: {
    売買高: ["売買高", ""],
    売買高MA1: ["移動MA1", "Volume_Short"],
    売買高MA2: ["移動MA2", "Volume_Middle"],
    売買高MA3: ["移動MA3", "Volume_Long"],
  },
  信用残: {
    買残: ["買残", ""],
    売残: ["売残", ""],
  },
  StandardDeviation: {
    標準偏差: ["標準偏差", "Kikan"],
  },
  HinoharaRatio: {
    RatioA: ["Aレシオ", "HinoharaRatio_Kikan"],
    RatioB: ["Bレシオ", ""],
  },
}

const ADDON_CHART_TECH = [
  "AverageN",
  "KSBolinger",
  "Envelope",
  "Ichimoku",
  "ParabolicDiv",
  "HLBand",
  "ATRChannel",
  "EMA",
  "Kaiki",
  "Vwap",
]

interface props {
  canvasId: string
  setVisible: Function
  option?: {
    noneScrollBarBtn?: boolean
    nonebackGroundOpacityBtn?: boolean
    noneHeader?: boolean
  }
}

const ChartInfoDialog = React.memo((props: props) => {
  const { canvasId, setVisible, option } = props
  const noneScrollBarBtn = _.get(option, "noneScrollBarBtn", false)
  const nonebackGroundOpacityBtn = _.get(
    option,
    "nonebackGroundOpacityBtn",
    false
  )
  const noneHeader = _.get(option, "noneHeader", false)

  const chartInfoDialogSelector = (state: any) =>
    state.chart[canvasId].chartInfoDialog
  const priceVolumeValueSelector = (state: any) =>
    state.chart[canvasId].priceVolumeValue
  const toolsSelector = (state: any) => state.chart[canvasId].tools
  const chartSettingSelector = (state: any) => state.chart.chartSetting

  const chartInfoDialog = useSelector(chartInfoDialogSelector)
  const priceVolumeValue = useSelector(priceVolumeValueSelector)
  const tools = useSelector(toolsSelector)
  const chartSetting = useSelector(chartSettingSelector)
  const [dataSource, setDataSource] = useState([])
  const [backGroundOpacity, setBackGroundOpacity] = useState(false)
  const [scrollBarVisible, setScrollBarVisible] = useState(false)

  const createDataSource = () => {
    const dataSource: Array<string[]> = []
    _.forEach(chartInfoDialog, (items: Array<string>, key) => {
      if (items[0].match(/(\.)/)) {
        const target = items[0].split(".")
        const category = _.includes(ADDON_CHART_TECH, target[0])
          ? "addon"
          : "sub"
        const convertData = _.get(CONVERT_TITLE, target, null)
        if (!convertData || !category || !target) return dataSource.push(items)
        // addon等で、設定できる数値がある場合のみ、()内に表示。
        items[0] = _.get(chartSetting, [
          category,
          target[0],
          "_Def",
          convertData[1],
          "default",
        ])
          ? `${convertData[0]}(${_.get(chartSetting, [
              category,
              target[0],
              "_Def",
              convertData[1],
              "default",
            ])})`
          : convertData[0]
      }
      dataSource.push(items)
    })
    return dataSource
  }

  useEffect(() => {
    setDataSource(createDataSource())
  }, [chartInfoDialog, chartSetting])

  useEffect(() => {}, [backGroundOpacity])

  return (
    <div
      id="chart-info-modal"
      className={ClassNames("tech-chart-buttons-setting chart-info-modal", {
        "background-transparent": backGroundOpacity,
      })}
    >
      {!noneHeader && (
        <div className="chart-info-header">
          {!noneScrollBarBtn && (
            <div
              className={ClassNames("chart-info-buttons", {
                active: scrollBarVisible,
              })}
            >
              <i
                className="material-icons background-icons"
                onClick={() => setScrollBarVisible(!scrollBarVisible)}
                title="サイズを固定する"
              >
                screen_lock_portrait
              </i>
            </div>
          )}
          {!nonebackGroundOpacityBtn && (
            <div
              className={ClassNames("chart-info-buttons", {
                active: backGroundOpacity,
              })}
            >
              <i
                className="material-icons background-icons"
                onClick={() => setBackGroundOpacity(!backGroundOpacity)}
                title="背景透過"
              >
                opacity
              </i>
            </div>
          )}
          <div className="chart-info-buttons">
            <i className="material-icons" onClick={() => setVisible(false)}>
              close
            </i>
          </div>
        </div>
      )}
      <div
        className="chart-info-content"
        style={
          scrollBarVisible
            ? { height: "20rem", overflowY: "scroll" }
            : { height: "100%" }
        }
      >
        {_.map(dataSource, (items, index) => {
          const rgba = `rgba(${items[2].R},${items[2].G},${items[2].B},${items[2].A})`
          return (
            <div
              key={index}
              className="chart-info-item"
              style={{ color: rgba }}
            >
              <div className="chart-info-item-title">{items[0]}</div>
              <div className="chart-info-item-value">{items[1]}</div>
            </div>
          )
        })}
        {!!_.find(tools, _.pick(TOOLS[5], pickTarget)) && (
          <div style={{ color: priceVolumeValue.color }}>
            <div className="chart-info-item">
              <div className="chart-info-item-title">価格帯</div>
              <div className="chart-info-item-value">
                {priceVolumeValue.width}
              </div>
            </div>
            <div className="chart-info-item">
              <div className="chart-info-item-title">累積売買高</div>
              <div className="chart-info-item-value">
                {priceVolumeValue.value}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
})

export default ChartInfoDialog
